import React from 'react';

import PagesRouter from 'routers/PagesRouter';

import ToastComponent from 'components/common/Toast';

import useApiDocsLoader from 'hooks/web_sample/useApiDocsLoader';

const App = () => {
  useApiDocsLoader();

  return (
    <>
      <ToastComponent />
      <PagesRouter />
    </>
  );
};

export default App;
